import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import noop from 'lodash/noop';

import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import { Checkbox } from '@els/els-react--checkbox';
import ProfileSettingsAccordionItem from '@Pages/ProfileSettings/Components/ProfileSettingsAccordionItem';

import './SynthesisConditionsPosition.scss';

// eslint-disable-next-line consistent-return
const getConditionsDisplayOptionIcon = (value) => {
  // eslint-disable-next-line default-case
  switch (value) {
    case 'modal':
      return `#icon-undocked`;
    case 'docked_bottom':
      return `#icon-docked-bottom`;
    case 'docked_right':
      return `#icon-docked-right`;
  }
};

function SynthesisConditionsPosition({
  preferences,
  conditionsDisplayOptionTitle,
  conditionsDisplayOptions,
  onChange,
  onSave,
  onClose,
  onReset,
}) {
  const renderValue = () => {
    return [
      { title: '', value: conditionsDisplayOptionTitle },
      {
        title: preferences.RX2_SYNTHESIS_CONDITIONS_ALWAYS_SHOW && ProfileSettingsConfig.Labels.alwaysDisplayConditions,
        value: preferences.RX2_SYNTHESIS_CONDITIONS_ALWAYS_SHOW && ProfileSettingsConfig.Labels.alwaysDisplayConditions,
      },
    ];
  };

  return (
    <ProfileSettingsAccordionItem
      onClose={onClose}
      onSave={onSave}
      label={ProfileSettingsConfig.Labels.conditionsDisplayBehavior}
      title={ProfileSettingsConfig.Labels.alwaysShowScreenBeforeCreatingAutoplan}
      value={renderValue()}
      resetButton
      titled
      validateOnSave
      onReset={onReset}
      className="synthesis-conditions-position-accordion-item preferences-accordion-item">
      <div className="preferences-accordion-item__wrapper">
        <div className="synthesis-conditions-position-accordion-item__conditions">
          {conditionsDisplayOptions.map((option) => (
            <div
              key={`conditions-display-option-${option.value}`}
              className="synthesis-conditions-position-accordion-item__conditions__container">
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
              <div
                className={cn(
                  'synthesis-conditions-position-accordion-item__conditions__container_item',
                  preferences.RX2_SYNTHESIS_CONDITIONS_POSITION === option.value &&
                    'synthesis-conditions-position-accordion-item__conditions__container_item-active'
                )}
                onClick={() => onChange('RX2_SYNTHESIS_CONDITIONS_POSITION', option.value)}>
                <div className="icon-wrapper">
                  <svg className="svg-icon">
                    <use xlinkHref={getConditionsDisplayOptionIcon(option.value)} />
                  </svg>
                </div>
              </div>
              <div className="synthesis-conditions-position-accordion-item__conditions__container_title">{option.label}</div>
            </div>
          ))}
        </div>
        <div className="preferences-accordion-item__option">
          <div className="preferences-accordion-item__option_label">{ProfileSettingsConfig.Labels.alwaysDisplayConditions}</div>
          <Checkbox
            name="RX2_SYNTHESIS_CONDITIONS_ALWAYS_SHOW"
            onChange={(event) => onChange('RX2_SYNTHESIS_CONDITIONS_ALWAYS_SHOW', event?.currentTarget?.checked)}
            checked={!!preferences.RX2_SYNTHESIS_CONDITIONS_ALWAYS_SHOW}
            id="RX2_SYNTHESIS_CONDITIONS_ALWAYS_SHOW"
            shouldHideLabel
            data-e2e="preferences-always-show-conditions-checkbox"
            label="Toggle to always show synthesis conditions screen before creating an autoplan"
            className="preferences-accordion-item__checkboxx"
          />
        </div>
      </div>
    </ProfileSettingsAccordionItem>
  );
}

SynthesisConditionsPosition.propTypes = {
  preferences: PropTypes.object,
  conditionsDisplayOptionTitle: PropTypes.string,
  conditionsDisplayOptions: PropTypes.array,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
  onReset: PropTypes.func,
};

SynthesisConditionsPosition.defaultProps = {
  conditionsDisplayOptions: [],
  onChange: noop,
  onSave: noop,
  onClose: noop,
  onReset: noop,
};

export default SynthesisConditionsPosition;
